import React from "react";
import { Dropdown, Flex, theme } from "antd";
import { HugeiconsIcon } from "@hugeicons/react";
import { EditTableIcon } from "@hugeicons/core-free-icons";
import { useTranslation } from "react-i18next";
import BtnAsLink from "../../Component/BtnAsLink";

const { useToken } = theme;

export const ColumnVisibilityDropdown = ({
  filterableColumns,
  visibleColumns,
  isColumnDisabled,
  toggleColumn,
  visibleCount,
  minVisibleColumns,
  disabled = false,
}) => {
  const { token } = useToken();
  const { t } = useTranslation();

  return (
    <Dropdown
      trigger={["click"]}
      disabled={disabled}
      dropdownRender={() => (
        <div
          style={{
            backgroundColor: token.colorBgElevated,
            borderRadius: token.borderRadiusLG,
            boxShadow: token.boxShadowSecondary,
            padding: "12px",
            minWidth: "250px",
          }}
        >
          <div className="mb-2 fw-bold">{t("COLUMN_VISIBILITY_MANAGE")}</div>
          <Flex vertical>
            {filterableColumns.map((column) => (
              <Flex
                key={column.key}
                justify="space-between"
                align="center"
                style={{ padding: "4px 0" }}
              >
                <label
                  htmlFor={`col-${column.key}`}
                  style={{
                    cursor: isColumnDisabled(column.key)
                      ? "not-allowed"
                      : "pointer",
                    opacity: isColumnDisabled(column.key) ? 0.6 : 1,
                  }}
                >
                  {column.name}
                </label>
                <input
                  type="checkbox"
                  id={`col-${column.key}`}
                  checked={visibleColumns[column.key]}
                  disabled={isColumnDisabled(column.key)}
                  onChange={() => toggleColumn(column.key)}
                  style={{
                    marginLeft: "8px",
                    cursor: isColumnDisabled(column.key)
                      ? "not-allowed"
                      : "pointer",
                  }}
                />
              </Flex>
            ))}
          </Flex>
          {visibleCount <= minVisibleColumns && (
            <div className="text-muted small mt-2">
              {t("COLUMN_VISIBILITY_MIN_COLUMNS", { count: minVisibleColumns })}
            </div>
          )}
        </div>
      )}
    >
      <span>
        <BtnAsLink
          className="btn-secondary"
          icon={<HugeiconsIcon icon={EditTableIcon} />}
          disabled={disabled}
        >
          <span>{t("COLUMN_VISIBILITY_ARRANGE_TABLE")}</span>
        </BtnAsLink>
      </span>
    </Dropdown>
  );
};
